import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import {DialogProps, ICreateAdminForm} from 'packages/common-types/base-types';
import {useForm} from 'react-hook-form';
import LinearProgress from '@material-ui/core/LinearProgress';
import {REQUIRED_FIELD_MESSAGE} from 'packages/constants/constants';
import {useState} from 'react';
import {GET_ADMINS} from 'packages/graphql/v2/queries';
import {CREATE_ADMIN} from 'packages/graphql/v2/mutations';
import {useMutation} from '@apollo/client';
import {Admin} from 'packages/common-types/schema-types';
import Swal from 'sweetalert2';

type Props = DialogProps & {};

type CreateAdminVars = {
  input: Admin;
};

type CreateAdminData = {
  createUserAdmin: Admin;
};

export default function NewAdmin(props: Props) {
  const {toggle, modalOpen} = props;
  const {handleSubmit, register, errors, reset} = useForm<ICreateAdminForm>();
  const [loading, setLoading] = useState(false);
  const [createAdmin] = useMutation<CreateAdminData, CreateAdminVars>(
    CREATE_ADMIN
  );

  const onSubmit = async (credentials: ICreateAdminForm) => {
    setLoading(true);
    try {
      const {email, fullName, phoneNumber, password} = credentials;
      await createAdmin({
        variables: {
          input: {
            email,
            fullName,
            phoneNumber,
            password,
          },
        },
        refetchQueries: [{query: GET_ADMINS}],
      });
      Swal.fire({
        title: 'Hecho',
        text: 'Administrador creado exitosamente',
        icon: 'success',
      });
      reset();
    } catch (ex) {
      console.error('Error while creating admin', ex);
      Swal.fire({
        title: 'Error',
        text: 'Error al crear un administrador',
        icon: 'error',
      });
    } finally {
      setLoading(false);
      toggle();
    }
  };

  return (
    <div>
      <Dialog
        open={modalOpen}
        onClose={toggle}
        aria-labelledby="create-administrator"
      >
        {loading && <LinearProgress />}
        <DialogTitle id="create-administrator">Crear administrador</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Para añadir un administrador ingresa el correo electrónico de la
            persona para crearle una cuenta y una contraseña segura.
          </DialogContentText>
          <form
            autoComplete="off"
            id="create-admin-form"
            onSubmit={handleSubmit(onSubmit)}
          >
            <TextField
              autoFocus
              error={errors.fullName && true}
              margin="dense"
              autoComplete="none"
              variant="outlined"
              helperText={errors.fullName && errors.fullName.message}
              inputRef={register({
                required: {
                  value: true,
                  message: REQUIRED_FIELD_MESSAGE,
                },
              })}
              name="fullName"
              id="name"
              label="Nombre completo"
              type="text"
              fullWidth
            />
            <TextField
              margin="dense"
              variant="outlined"
              name="phoneNumber"
              autoComplete="none"
              error={errors.phoneNumber && true}
              helperText={errors.phoneNumber && errors.phoneNumber.message}
              inputRef={register({
                required: {
                  value: true,
                  message: REQUIRED_FIELD_MESSAGE,
                },
              })}
              id="phone"
              label="Número de teléfono"
              type="tel"
              fullWidth
            />
            <TextField
              variant="outlined"
              margin="dense"
              name="email"
              id="email"
              autoComplete="none"
              error={errors.email && true}
              helperText={errors.email && errors.email.message}
              inputRef={register({
                required: {
                  value: true,
                  message: REQUIRED_FIELD_MESSAGE,
                },
              })}
              label="Correo electrónico"
              type="email"
              fullWidth
            />
            <TextField
              margin="dense"
              variant="outlined"
              name="password"
              id="password"
              inputRef={register({
                required: {
                  value: true,
                  message: REQUIRED_FIELD_MESSAGE,
                },
              })}
              label="Contraseña"
              type="password"
              fullWidth
            />
          </form>
        </DialogContent>
        <DialogActions>
          <Button onClick={toggle} color="primary">
            Cancel
          </Button>
          <Button type="submit" form="create-admin-form" color="primary">
            Hacer administrador
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
